import { render, staticRenderFns } from "./FormSaleInvoice.vue?vue&type=template&id=2730d495"
import script from "./FormSaleInvoice.vue?vue&type=script&lang=js"
export * from "./FormSaleInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports